<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_5">Dedicated</a></p><a id="page_5">
<p class="centerb">To my Mom and Dad</p>
<p class="center">To Mom for instilling in me the joy of reading;</p>
<p class="center">To Dad for teaching me how to write a story</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?7c321256